// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AppEvent } from '@interfaces/interfaces';

@Component({
    selector: 'how-to',
    templateUrl: './how-to.component.html',
    styleUrls: ['./how-to.component.scss'],
})
export class HowToComponent implements OnInit {
    @Output() public outEvent: EventEmitter<AppEvent> = new EventEmitter();
    public showArrow = true;

    ngOnInit(): void {
        if (window.location.pathname.includes('main')) {
            this.showArrow = false;
        }
    }

    public continue(): void {
        this.outEvent.emit({
            context: 'step-1-complete',
            data: {},
        });
    }
}
